module.exports = __webpack_public_path__ + "static/media/4.eee0cde6.jpg";